import { render, staticRenderFns } from "./SelectionPlaceholder.vue?vue&type=template&id=652cab26"
import script from "./SelectionPlaceholder.vue?vue&type=script&lang=js"
export * from "./SelectionPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports